import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Notification } from "../../models/notification.model";

import { AuthProvider } from '../auth/auth';

@Injectable()
export class NotificationProvider extends Api {

  private _notifications: BehaviorSubject<Notification[]> = new BehaviorSubject([]);

  private _unreadNotifications: BehaviorSubject<number> = new BehaviorSubject(0);

  public readonly notifications: Observable<Notification[]> = this._notifications.asObservable();

  public readonly unreadNotifications: Observable<number> = this._unreadNotifications.asObservable();

  constructor(public http: HttpClient, private authProvider:AuthProvider) {
    super(http);

    // fetch notifications
    this._fetch();

    // check every XX minutes for new notifications
    setInterval(() => {
      if (this.authProvider.isLoggedIn()) {
        this._fetch();
      }
    }, 60000);
  }

  private _fetch() {
    this.http.get<Notification[]>(`${this.url}/notifications`).subscribe(
      response => {
        this._notifications.next(response.map((notification) => new Notification(notification)));
        this._unreadNotifications.next(response.filter(item => item.read === null).length);
      },
      err => this.handleError(err)
    );
  }

  clear() {
    this._notifications.next([]);
    this._unreadNotifications.next(0);
  }

  readAll(): Observable<any> {
    return this.http
      .get<any>(`${this.url}/notifications/read-all`)
      .do(() => this._fetch())
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/notification/notification.ts